var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [_c("stepheader", { attrs: { step: _vm.step } }), _vm._v(" "), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "body current",
        attrs: {
          id: "wizard2-p-0",
          role: "tabpanel",
          "aria-labelledby": "wizard2-h-0",
          "aria-hidden": "false",
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm._v(
              "\n              Stiamo verificando lo stato del dispositivo...\n          "
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }